import {
    CreateButton,
    DataTable,
    DateField,
    ExportButton,
    List,
    ReferenceField,
    SearchInput,
    SelectInput,
    TextField,
} from "@/components/admin";
import { Card } from "@/components/ui/card";
import { Calendar, Mail, Phone } from "lucide-react";
import { useRecordContext } from "ra-core";
import { TopToolbar } from "../../layout/TopToolbar";
import { HRStatusBadge } from "../HRStatusBadge";

const StatusBadge = () => {
  const record = useRecordContext();
  if (!record) return null;
  const s = record.status || "active";
  return <HRStatusBadge status={s} />;
};

const ContactCell = () => {
  const record = useRecordContext();
  if (!record) return null;
  return (
    <div className="flex flex-col gap-1">
      {record.email && (
        <div className="flex items-center gap-1.5 text-muted-foreground text-xs">
          <Mail className="w-3.5 h-3.5" />
          <span className="truncate max-w-[150px]">{record.email}</span>
        </div>
      )}
      {record.phone && (
        <div className="flex items-center gap-1.5 text-muted-foreground text-xs">
          <Phone className="w-3.5 h-3.5" />
          {record.phone}
        </div>
      )}
    </div>
  );
};

const filters = [
  <SearchInput key="q" source="q" alwaysOn />,
  <SelectInput
    key="status"
    source="status"
    choices={[
      { id: "active", name: "Active" },
      { id: "inactive", name: "Inactive" },
      { id: "terminated", name: "Terminated" },
      { id: "on_leave", name: "On Leave" },
    ]}
  />,
  <SelectInput
    key="employment_type"
    source="employment_type"
    label="Type"
    choices={[
      { id: "full_time", name: "Full Time" },
      { id: "part_time", name: "Part Time" },
      { id: "contract", name: "Contract" },
      { id: "intern", name: "Intern" },
    ]}
  />,
];

export const EmployeeList = () => (
  <List
    title="Employees"
    filterInHeader={true}
    actions={
      <TopToolbar className="flex items-center gap-2">
        <ExportButton />
        <CreateButton label="Add Employee" />
      </TopToolbar>
    }
    filters={filters}
    sort={{ field: "name", order: "ASC" }}
    className="p-6"
  >
    <Card className="border border-border rounded-xl bg-card shadow-sm overflow-hidden">
      <DataTable rowClick="show">
        <DataTable.Col
          source="employee_code"
          label="Code"
          className="font-mono text-xs bg-muted px-2 py-0.5 rounded border"
        />
        <DataTable.Col source="name" label="Name" className="font-semibold" />
        <DataTable.Col label="Department">
          <ReferenceField
            source="department_id"
            reference="hr_departments"
            link={false}
          >
            <TextField source="name" />
          </ReferenceField>
        </DataTable.Col>
        <DataTable.Col label="Designation">
          <ReferenceField
            source="designation_id"
            reference="hr_designations"
            link={false}
          >
            <TextField source="title" />
          </ReferenceField>
        </DataTable.Col>
        <DataTable.Col label="Contact">
          <ContactCell />
        </DataTable.Col>
        <DataTable.Col label="Status">
          <StatusBadge />
        </DataTable.Col>
        <DataTable.Col label="Joined">
          <div className="flex items-center gap-2">
            <Calendar className="w-3.5 h-3.5" />
            <DateField source="joining_date" />
          </div>
        </DataTable.Col>
      </DataTable>
    </Card>
  </List>
);
